import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setLocalStorage } from 'src/utils';
import useAuthUser from 'src/hooks/useAuthUser';
import { updateChatConfiguration } from 'src/redux/modules/chats/chatsActions';
import { ReactComponent as SlackIcon } from 'src/assets/icons/slack.svg';
import { ReactComponent as MSTeamsIcon } from 'src/assets/icons/microsoft-teams.svg';
import useToast from 'src/hooks/useToast';
import Button from '../../components/SimpleButton';
import PageWrapper from '../../components/PageWrapper';
import { Heading, Description, ContentStyled } from './style';

const configData = {
  slack: {
    title: 'Slack',
    icon: <SlackIcon height="28" width="52" />
  },
  msteams: {
    title: 'Microsoft Teams',
    icon: <MSTeamsIcon height="28" width="52" />
  }
};

const ChatIntegrationsEditor = ({ match, chatInfoLoader, updateChatConfiguration }) => {
  const config = configData[match.params.platform];
  const authenticatedUser = useAuthUser();
  const history = useHistory();
  const { toast } = useToast();

  const handleConnect = () => {
    updateChatConfiguration(authenticatedUser.company.id, null)
      .then(() => {
        setLocalStorage({ chatPlatformStep: match.params.platform });
        history.replace('/signup/chat');
      })
      .catch(() => {
        toast.error('Something went wrong, please try again.');
      });
  };

  if (!config) return null;

  return (
    <PageWrapper title={config.title} isBackButton isModalContent>
      <ContentStyled>
        <Heading>
          {config.icon}
          {config.title}
        </Heading>
        <Description>{`Connect with ${config.title}, this is a one time setup.`}</Description>
        <Button size="large" full isLoader={chatInfoLoader === 'pending'} onClick={handleConnect}>
          Connect
        </Button>
      </ContentStyled>
    </PageWrapper>
  );
};

ChatIntegrationsEditor.propTypes = {
  match: PropTypes.object.isRequired,
  chatInfoLoader: PropTypes.string.isRequired,
  updateChatConfiguration: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  chatInfoLoader: state.chatsReducer.chatInfoLoader
});

const mapDispatchToProps = dispatch => ({
  updateChatConfiguration: (companyId, chatConfig) =>
    dispatch(updateChatConfiguration(companyId, chatConfig))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatIntegrationsEditor);
